import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from './AuthProvider';
import Loader from "./Components/GlobalLoader/Loader";

export default function RequireAuth() {
  const { user, isAuthLoading } = useAuth();
  const location = useLocation();

  // Don't bounce to /login until the boot-time GET /auth/me has settled
  if (isAuthLoading) {
    return (
      <div className="loader">
        <Loader message="Please Wait" />
      </div>
    );
  }

  return user ? <Outlet /> : <Navigate to="/login" replace state={{ from: location }} />;
}
